export enum puzzleSortingEnum {
  alphabetical = 'alphabetical',
  popularity = 'popularity'
}
